module.exports = __webpack_public_path__ + "img/NationalTechnicalInventionAward.03ab9c80.jpg";